import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  module: {},
  allModuleCategory: {
    children: [],
    id: 0,
    name: "",
    tags: []
  },
  tagCategoryList: {
    children: [],
    name: ""
  }
}

const moduleFilterSlice = createSlice({
  name: "moduleFilter",
  initialState,
  reducers: {
    moduleFilter: (state, action) => {
      state.module = action.payload.data;
    },
    saveAllModuleCategory: (state, action) => {
      state.allModuleCategory = action.payload.data;
    },
    saveTagCategoryList: (state, action) => {
      state.tagCategoryList = action.payload.data;
    }
  },

});

export const { moduleFilter, saveAllModuleCategory, saveTagCategoryList } = moduleFilterSlice.actions;
export default moduleFilterSlice.reducer;